module.exports = __webpack_public_path__ + "img/arrow-up-order.0ffbbe0f.svg";